import { useTranslation } from 'react-i18next'

import { NUMBER_SIZE } from '../../../constants/size'
import { preventDefault, stopPropagation } from '../../../utils/events'
import Button from '../../Button'

function DatePickerRangeToggle({
  height = NUMBER_SIZE.size16,
  isRange,
  ...restProps
}) {
  const { t } = useTranslation()

  function handleMouseDown(e) {
    preventDefault(e)
    stopPropagation(e)
  }

  return (
    <Button.Text {...restProps} height={height} onMouseDown={handleMouseDown}>
      {isRange
        ? t('Calendar.SelectSingleDateKey')
        : t('Calendar.SelectDateRangeKey')}
    </Button.Text>
  )
}

export default DatePickerRangeToggle
